<app-profile-shell [isLoading]="isLoading()" [tabs]="profileTabs()" [(activeTab)]="activeTab"
                    [containerClass]="role() === 'Student' ? 'container-profile-student' : ''"
                    [account]="account()" [profileCity]="shellProfileCity()" [displayName]="shellProfileName()" (editAvatar)="editAvatar()">

  <!-- Top panel extra -->
  <div topPanelExtra>
    @switch (role()) {
      @case ('Student') {
        @if (studentProfile()) {
          <app-student-top-panel [entity]="studentProfile()!" (profileChanged)="reloadProfile()" />
        }
      }
      @case ('Teacher') {
        @if (teacherProfile()) {
          <app-teacher-top-panel [profile]="teacherProfile()!" />
        }
      }
    }
  </div>

  <!-- Top panel actions (student only) -->
  <div topPanelActions>
    @if (role() === 'Student' && studentProfile()) {
      <app-student-top-panel-actions [entity]="studentProfile()!" (profileChanged)="reloadProfile()" />
    }
  </div>

  <!-- Contact details extra (display:contents so its rows join the shell grid) -->
  <div contactDetailsExtra class="contents">
    @switch (role()) {
      @case ('Student') {
        @if (studentProfile()) {
          <app-student-contact-details [entity]="studentProfile()!" />
        }
      }
      @case ('Teacher') {
        @if (teacherProfile()) {
          <app-teacher-contact-details [profile]="teacherProfile()!" />
        }
      }
    }
  </div>

  <!-- Sidebar extra (student only) -->
  <div profileSidebarExtra>
    @if (role() === 'Student' && studentProfile()) {
      <app-student-sidebar [entity]="studentProfile()!" [remainingSubjects]="profileRemainingSubjects()" (goToSection)="goToResumeSection($event)" />
    }
  </div>

  <!-- Tab content -->
  <div profileTabContent>
    @switch (role()) {
      @case ('Student') {
        @if (studentProfile()) {
          @switch (activeTab()) {
            @case ('cv') {
              <app-student-cv-tab [entity]="studentProfile()!" (profileChanged)="reloadProfile()" />
            }
            @case ('oproepen') {
              <app-student-oproepen-tab [entity]="studentProfile()!" />
            }
            @case ('matchtest') {
              <app-student-matchtest-tab [entity]="studentProfile()!" [matchtest]="matchtest()" (matchtestLoaded)="matchtest.set($event)" (tabChanged)="activeTab.set($event)" />
            }
            @case ('matches-company') {
              <app-student-matches-company-tab [entity]="studentProfile()!" />
            }
            @case ('matches-jobposting') {
              <app-student-matches-job-tab [entity]="studentProfile()!" />
            }
            @case ('dna') {
              @defer (when activeTab() === 'dna') {
                <app-student-dna-tab [entity]="studentProfile()!" (profileChanged)="reloadProfile()" />
              }
            }
            @case ('experienceday') {
              <app-student-experienceday-tab [entity]="studentProfile()!" />
            }
          }
        }
      }
      @case ('Teacher') {
        @if (teacherProfile()) {
          @switch (activeTab()) {
            @case ('profile') {
              <app-teacher-profile-tab [profile]="teacherProfile()!" [schoolClasses]="schoolClasses()" (profileChanged)="reloadProfile()" />
            }
            @case ('students') {
              <app-teacher-students-tab [profile]="teacherProfile()!" [schoolClasses]="schoolClasses()" />
            }
          }
        }
      }
    }
  </div>

</app-profile-shell>
